import Input from '@mui/joy/Input';

export default function BasicInput() {
  return <Input placeholder="Type in here…" />;
}
